<template>
	<div class="container">
		<div class="content">
			<!-- 面包屑导航 -->
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/my/index' }">个人中心</el-breadcrumb-item>
					<el-breadcrumb-item>我的理赔</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<!-- 理赔列表卡片 -->
			<div class="policies-card">
				<!-- 状态筛选标签页 -->
				<div class="product-tab">
					<el-tabs v-model="activeStatus" @tab-click="handleTabClick">
						<el-tab-pane 
							v-for="(item, index) in statusOptions" 
							:key="index" 
							:label="item.name" 
							:name="item.name"
						/>
					</el-tabs>
				</div>
				
				<!-- 搜索表单 -->
				<el-form :inline="true" class="search-form" @submit.native.prevent="handleSearch">
					<el-form-item label="保单号" size="medium">
						<el-input 
							v-model="searchForm.policyNo" 
							placeholder="请输入保单号"
							clearable
							@clear="handleReset"
						/>
					</el-form-item>
					<el-form-item size="medium">
						<el-button @click="handleReset" plain>重置</el-button>
					</el-form-item>
					<el-form-item size="medium">
						<el-button 
							native-type="submit" 
							class="search-btn" 
							type="primary"
							:loading="loading"
						>
							搜索
						</el-button>
					</el-form-item>
				</el-form>
				
				<!-- 理赔列表表格 -->
				<div class="table-container" v-loading="loading">
					<template v-if="claimList.length > 0">
						<table class="policies-table">
							<thead>
								<tr>
									<th>理赔保单</th>
									<th>保单号</th>
									<th>出险人姓名</th>
									<th>理赔状态</th>
									<th>操作</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in claimList" :key="item.id || index">
									<td>
										{{ item.goods_name }} {{ item.goods_specs_name }}
									</td>
									<td>保单号: {{ item.policy_no }}</td>
									<td>{{ item.insurant_name }}</td>
									<td>
										<span :class="['policy-status', `status-${item.status}`]">
											{{ item.statusText }}
										</span>
									</td>
									<td>
										<div class="policy-actions">
											<button 
												@click="handleViewDetail(item.id)" 
												class="action-btn primary"
											>
												查看详情
											</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</template>
					
					<!-- 空状态 -->
					<el-empty 
						v-else 
						description="暂无理赔记录"
						:image-size="120"
					/>
				</div>
				
				<!-- 分页 -->
				<div class="pagination" v-if="claimList.length > 0 && total > pagination.pageSize">
					<el-pagination 
						background 
						layout="prev, pager, next, total, jumper" 
						:total="total" 
						:page-size="pagination.pageSize"
						:current-page="pagination.currentPage"
						@current-change="handlePageChange"
					/>
				</div>
			</div>
		</div>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	
	// 状态选项配置
	const STATUS_OPTIONS = [
		{ name: '全部', value: '' },
		{ name: '进行中', value: 0 },
		{ name: '未通过', value: 2 },
		{ name: '已完成', value: 1 },
	];
	
	export default {
		name: 'ClaimList',
		components: {
			mainFooter,
		},
		data() {
			return {
				// 搜索表单
				searchForm: {
					policyNo: '',
					status: '',
				},
				// 分页配置
				pagination: {
					currentPage: 1,
					pageSize: 10,
					order: 'id',
					isReverse: 1,
				},
				// 数据
				claimList: [],
				total: 0,
				// 状态
				activeStatus: '全部',
				statusOptions: STATUS_OPTIONS,
				loading: false,
			};
		},
		computed: {
			// 构建请求参数
			requestParams() {
				return {
					_page: this.pagination.currentPage,
					_size: this.pagination.pageSize,
					_order: this.pagination.order,
					_isreverse: this.pagination.isReverse,
					policy_no: this.searchForm.policyNo,
					status: this.searchForm.status,
				};
			},
		},
		mounted() {
			this.fetchClaimList();
		},
		methods: {
			/**
			 * 处理标签页切换
			 */
			handleTabClick(tab) {
				this.pagination.currentPage = 1;
				this.searchForm.status = this.statusOptions[tab.index].value;
				this.fetchClaimList();
			},
			
			/**
			 * 处理分页变化
			 */
			handlePageChange(page) {
				this.pagination.currentPage = page;
				this.fetchClaimList();
			},
			
			/**
			 * 处理搜索
			 */
			handleSearch() {
				this.pagination.currentPage = 1;
				this.fetchClaimList();
			},
			
			/**
			 * 处理重置
			 */
			handleReset() {
				this.searchForm.policyNo = '';
				this.pagination.currentPage = 1;
				this.fetchClaimList();
			},
			
			/**
			 * 查看详情
			 */
			handleViewDetail(id) {
				this.$navto('/my/claimDetail?id=' + id);
			},
			
			/**
			 * 获取理赔列表
			 */
			fetchClaimList() {
				var _this = this;
				_this.loading = true;
				_this.$get('app-order-claim', _this.requestParams, true).then(function(res) {
					_this.claimList = res.data || [];
					// 修复可选链操作符问题
					_this.total = (res.extra && res.extra.pageInfo && res.extra.pageInfo.count) || 0;
				}).catch(function(error) {
					_this.$message.error(error.message || '获取数据失败，请重试');
					_this.claimList = [];
					_this.total = 0;
				}).finally(function() {
					_this.loading = false;
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 85%;
				margin: 15px auto 30px;
			}

			/* 平板适配 */
			@media (max-width: 1023px) and (min-width: 768px) {
				width: 95%;
				margin: 10px auto 20px;
			}

			/* 手机适配 */
			@media (max-width: 767px) {
				width: 100%;
				margin: 0 auto 20px;
				padding: 0 15px;
			}

			.breadcrumb {
				margin-bottom: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					margin-bottom: 15px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					margin-bottom: 12px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					margin-bottom: 10px;
					padding: 0 10px;
				}
			}

			/* 保单列表 */
			.policies-card {
				background: white;
				border-radius: 12px;
				padding: 24px;
				box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
				margin-top: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 20px;
					margin-top: 15px;
					border-radius: 10px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 16px;
					margin-top: 12px;
					border-radius: 8px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 12px;
					margin-top: 10px;
					border-radius: 6px;
					overflow-x: auto;
				}
				
				.pagination {
					display: flex;
					justify-content: center;
					margin-top: 30px;
					
					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-top: 25px;
					}

					/* 平板适配 */
					@media (max-width: 1023px) and (min-width: 768px) {
						margin-top: 20px;
					}

					/* 手机适配 */
					@media (max-width: 767px) {
						margin-top: 15px;
					}
					
					::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
						background-color: #2280FD;
						color: white;
					}
					
					::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
						color: #2280FD;
					}

					/* 手机分页适配 */
					@media (max-width: 767px) {
						::v-deep .el-pagination {
							display: flex;
							flex-wrap: wrap;
							justify-content: center;
						}
						
						::v-deep .el-pagination .el-pager li,
						::v-deep .el-pagination .btn-prev,
						::v-deep .el-pagination .btn-next {
							min-width: 32px;
							height: 32px;
							line-height: 32px;
							font-size: 12px;
						}
					}
				}
				
				.product-tab {
					margin-bottom: 20px;
					
					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-bottom: 16px;
					}

					/* 平板适配 */
					@media (max-width: 1023px) and (min-width: 768px) {
						margin-bottom: 12px;
					}

					/* 手机适配 */
					@media (max-width: 767px) {
						margin-bottom: 10px;
					}
					
					:deep(.el-tabs) {
						.el-tabs__item {
							font-size: 16px;
							color: #999999;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 15px;
								padding: 0 15px;
							}

							/* 平板适配 */
							@media (max-width: 1023px) and (min-width: 768px) {
								font-size: 14px;
								padding: 0 12px;
							}

							/* 手机适配 */
							@media (max-width: 767px) {
								font-size: 13px;
								padding: 0 8px;
							}
						}
						.el-tabs__item.is-active {
							color: #2280FD; 
						}
						.el-tabs__active-bar {
							background-color: #2280FD;
						}
					}
				}
				
				.search-form {
					margin-bottom: 20px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-bottom: 16px;
					}

					/* 平板适配 */
					@media (max-width: 1023px) and (min-width: 768px) {
						margin-bottom: 12px;
					}

					/* 手机适配 */
					@media (max-width: 767px) {
						margin-bottom: 10px;
					}
					
					.el-form-item {
						margin-bottom: 16px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							margin-bottom: 12px;
							margin-right: 12px;
						}

						/* 平板适配 */
						@media (max-width: 1023px) and (min-width: 768px) {
							margin-bottom: 10px;
							margin-right: 10px;
						}

						/* 手机适配 */
						@media (max-width: 767px) {
							margin-bottom: 8px;
							margin-right: 0;
							width: 100%;
						}
						
						.search-btn {
							background-color: #2280FD;
						}
						
						.el-button {
							width: 100px;
							border-radius: 5px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 90px;
							}

							/* 平板适配 */
							@media (max-width: 1023px) and (min-width: 768px) {
								width: 80px;
								font-size: 13px;
							}

							/* 手机适配 */
							@media (max-width: 767px) {
								width: 100%;
								margin-bottom: 8px;
							}
						}
						
						.el-input {
							width: 300px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 250px;
							}

							/* 平板适配 */
							@media (max-width: 1023px) and (min-width: 768px) {
								width: 200px;
							}

							/* 手机适配 */
							@media (max-width: 767px) {
								width: 100%;
							}
						}
						
						::v-deep .el-form-item__label {
							color: #999999 !important;
							font-size: 16px;
							text-align: left;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 15px;
							}

							/* 平板适配 */
							@media (max-width: 1023px) and (min-width: 768px) {
								font-size: 14px;
							}

							/* 手机适配 */
							@media (max-width: 767px) {
								font-size: 14px;
								width: 100%;
								text-align: left;
								margin-bottom: 4px;
							}
						}
					}

					/* 手机适配 - 搜索表单垂直排列 */
					@media (max-width: 767px) {
						:deep(.el-form--inline) {
							.el-form-item {
								display: block;
								margin-right: 0;
							}
						}
					}
				}
				
				.table-container {
					min-height: 200px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						min-height: 180px;
					}

					/* 平板适配 */
					@media (max-width: 1023px) and (min-width: 768px) {
						min-height: 160px;
					}

					/* 手机适配 */
					@media (max-width: 767px) {
						min-height: 140px;
					}
				}
			}

			.policies-table {
				width: 100%;
				border-collapse: collapse;

				/* 手机适配 - 表格水平滚动 */
				@media (max-width: 767px) {
					min-width: 600px;
				}
			}

			.policies-table th {
				background: #f8f9fa;
				padding: 16px;
				text-align: left;
				font-weight: 600;
				color: #333;
				border-bottom: 1px solid #e0e0e0;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 14px 12px;
					font-size: 14px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 12px 10px;
					font-size: 13px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 10px 8px;
					font-size: 12px;
				}
			}

			.policies-table td {
				padding: 16px;
				border-bottom: 1px solid #f0f0f0;
				color: #666666;
				font-size: 14px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 14px 12px;
					font-size: 13px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 12px 10px;
					font-size: 12px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 10px 8px;
					font-size: 12px;
				}
			}

			.policies-table tr:hover {
				background: #f8f9fa;
			}

			.policy-name {
				font-weight: 500;
				color: #333;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 14px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					font-size: 13px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					font-size: 13px;
				}
			}

			.policy-desc {
				font-size: 12px;
				color: #666;
				margin-top: 4px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 11px;
					margin-top: 3px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					font-size: 11px;
					margin-top: 2px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					font-size: 10px;
					margin-top: 2px;
				}
			}

			.policy-status {
				padding: 6px 12px;
				border-radius: 20px;
				font-size: 12px;
				font-weight: 500;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 5px 10px;
					font-size: 11px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 4px 8px;
					font-size: 10px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 3px 6px;
					font-size: 10px;
					display: inline-block;
					text-align: center;
					min-width: 60px;
				}
			}

			.status-0 {
				background: #fff3e0;
				color: #ef6c00;
			}
			
			.status-1 {
				background: #e8f5e9;
				color: #2e7d32;
			}
			
			.status-2 {
				background: #ebeae6;
				color: #6b6a69;
			}
			
			.policy-actions {
				display: flex;
				gap: 8px;

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					gap: 6px;
					flex-direction: column;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					gap: 4px;
					flex-direction: column;
				}
			}

			.action-btn {
				padding: 6px 12px;
				border: 1px solid #e0e0e0;
				border-radius: 6px;
				background: white;
				color: #666;
				font-size: 12px;
				cursor: pointer;
				transition: all 0.3s ease;
				white-space: nowrap;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 5px 10px;
					font-size: 11px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 4px 8px;
					font-size: 10px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 3px 6px;
					font-size: 10px;
					min-width: 60px;
				}
			}

			.action-btn:hover {
				border-color: #2280FD;
				color: #2280FD;
			}

			.action-btn.primary {
				background: #2280FD;
				color: white;
				border-color: #2280FD;
			}

			.action-btn.primary:hover {
				background: #1a6fd0;
			}
			
			.empty-state {
				text-align: center;
				padding: 60px 0;
				color: #999;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 50px 0;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 40px 0;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 30px 0;
				}
				
				img {
					width: 120px;
					height: 120px;
					margin-bottom: 16px;
					opacity: 0.6;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						width: 100px;
						height: 100px;
					}

					/* 平板适配 */
					@media (max-width: 1023px) and (min-width: 768px) {
						width: 80px;
						height: 80px;
					}

					/* 手机适配 */
					@media (max-width: 767px) {
						width: 60px;
						height: 60px;
					}
				}
				
				p {
					font-size: 14px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 13px;
					}

					/* 平板适配 */
					@media (max-width: 1023px) and (min-width: 768px) {
						font-size: 12px;
					}

					/* 手机适配 */
					@media (max-width: 767px) {
						font-size: 12px;
					}
				}
			}
		}
	}
</style>